import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ConnectToChannelManuallyPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ConnectToChannelManuallyPopup" */ './Container'),
  'popup'
);
